(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/player-login/views/partials/qr-prolong.js') >= 0) return;  svs.modules.push('/modules/player-login/views/partials/qr-prolong.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.player_login=_svs.player_login||{};
_svs.player_login.templates=_svs.player_login.templates||{};
svs.player_login.templates.qr_prolong = Handlebars.template({"0":function(container,depth0,helpers,partials,data) {
    return "Förläng tid";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"js-prolong-qr animate hide animate-show padding-top-1 padding-bottom-1\">\n    <div aria-live=\"polite\" aria-atomic=\"true\" class=\"aria-countdown-timer-screen-reader\" role=\"timer\">\n        Tid kvar: <span class=\"js-qr-countdown-aria\">?</span> sekunder\n    </div>\n    <p>Tid kvar: <span class=\"js-qr-countdown\">30</span> s</p>\n    "
    + ((stack1 = (lookupProperty(helpers,"ui")||(depth0 && lookupProperty(depth0,"ui"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"button",{"name":"ui","hash":{"block":true,"transparent":true,"size":300,"class":"js-prolong-btn"},"fn":container.program(0, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":6,"column":4},"end":{"line":6,"column":98}}})) != null ? stack1 : "")
    + "\n</div>";
},"useData":true});
Handlebars.partials['svs-player_login-qr_prolong'] = svs.player_login.templates.qr_prolong;
})(svs, Handlebars);


 })(window);